import React from 'react';
import { FieldGroup } from '../../components';

export function PlanToggle({ plan, feature }) {
  return (
    <div className="plan-toggle">
      <FieldGroup
        name={`${feature}.${plan}`}
        type="switch"
      />
    </div>
  );
}
